// extracted by mini-css-extract-plugin
export default {"novoTipoServico":"styles_novoTipoServico__2T4aE","containerList":"styles_containerList__834g1","listagem":"styles_listagem__Tfrrz"};